import { render } from "./NavIcon.vue?vue&type=template&id=d27c0750"
import script from "./NavIcon.vue?vue&type=script&lang=js"
export * from "./NavIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"NavIcon.vue"]])

export default __exports__